import { useEffect, useState } from "react";
import { getPayload, validateASN, validateMobileField } from "./Service/InboundServices";
import { useForm } from "react-hook-form";
import { useNavigate, useParams } from "react-router-dom";
import { ReturnReceiveItem } from "../Return/Receive/ReturnReceiveItem.type";
import Breadcrumb from "../../../Shared/BreadCrumb/Breadcrumb";
import MobileFooter from "./Mobile/Footer";
import RightSection from "./Mobile/RightSection";
import LeftSection from "./Mobile/LeftSection";
import ScanPanel from "./Mobile/ScanPanel";
import { getAsnDetails } from "../service/asnOverview.service";
import { ASN } from "../model/asnOverview.model";
import MobileHeader from "./Mobile/Header";
import ASNValidateResponse, { BackButton } from "./Model/AsnRecive.model";
import useASNMobileStore from "../../../store/asnmobile/useStore";
import toast from "react-hot-toast";
import Loader from "../../../Components/GlobalLoader/Loader";
import useMenuStore from "../../../store/menu/useMenuStore";

const ReceiveCreate: React.FC = () => {
  const {items,loading} =useMenuStore();
  const { id } = useParams<{ id: string }>();
  const { desktopBottomSection, desktopRightSection, setDesktopBottomSection, setDesktopRightSection } = useASNMobileStore();
  const [isLoading, setIsLoading] = useState<boolean>(true);
  const navigation = useNavigate();
  const [valueChecker, setValueChecker] = useState({
    error: false,
    errorMessage: "",
  });
  const [formData, setFormData] = useState<{ [key: string]: any }>({});
  const [textValue, setTextValue] = useState<string>("");
  const [asnDetail, setAsnDetail] = useState<ASN>();
  const [asnValidateResponse, setAsnValidateResponse] = useState<ASNValidateResponse>();
  const { register } = useForm({
    defaultValues: {},
  });

  useEffect(() => {
    const fetchData = async () => {
      try {
        setIsLoading(true);
        const details = await getAsnDetails(id);
        setAsnDetail(details.data);
        await firstStepMobile();
      } catch (error) {
        console.error("Error fetching ASN details: ", error);
      } finally {
        setIsLoading(false);
      }
    };
    fetchData();
  }, [id]);

  const firstStepMobile = async () => {
    const payload = getPayload("asnreceive", 1, id);
    const response = await validateASN(payload);
    let res = response as any;
    if (res?.error?.code) {
      toast.error(res.error.detail, { duration: 20000 });
      return;
    }
    if (response.data?.attributes.desktop_bottom_section) {
      setDesktopBottomSection(response.data?.attributes.desktop_bottom_section);
    }
    if (response.data?.attributes.desktop_right_section) {
      setDesktopRightSection(response.data?.attributes.desktop_right_section);
    }
    setAsnValidateResponse(response.data);
  };

  const handleRowClick = (data: ReturnReceiveItem) => {
  };

  const handleFieldChange = (fieldName: string, value: any) => {
    if (!value) {
      if (!valueChecker.errorMessage) {
        setValueChecker({
          error: false,
          errorMessage: `This field is required.`,
        });
      }
    } else {
      setFormData({ ...formData, [fieldName]: value });
      setValueChecker({
        error: true,
        errorMessage: "",
      });
    }
  };

  const handleAction = (name: string, action: BackButton) => {
    if (name == 'back') {
      firstStepMobile();
    } else if (name == 'complete') {
      validateMobileField(action.callback_url, action.call_back_url_params).then(() => {
        navigation("/inbound/asn/receive");
      });
    }
  };

  return !isLoading ? (
    <div>
      <Breadcrumb navigationData={items} />
      <div className="d-flex flex-column min-h-85">
        {/* Header */}
        <MobileHeader
          asnDetail={asnDetail}
        />

        {/* Main Body */}
        <div className="d-flex justify-content-between my-3">

          {/* Left Section: Scan Panel */}
          <div className="col d-flex flex-column justify-content-between scanning-area">
            <ScanPanel
              register={register}
              setValueChecker={setValueChecker}
              asnValidateResponse={asnValidateResponse}
              setAsnValidateResponse={setAsnValidateResponse}
              textValue={textValue}
              handleFieldChange={handleFieldChange}
              setTextValue={setTextValue}
              valueChecker={valueChecker}
            />

            {/*left item table */}
            <LeftSection desktopBottomSection={desktopBottomSection} asnValidateResponse={asnValidateResponse} handleRowClick={handleRowClick} />
          </div>

          {/* Right Section*/}
          <div className="col-8 ms-2">
            <div className="top-tab h-100 p-2">
              <div>
                <RightSection desktopRightSection={desktopRightSection} asnValidateResponse={asnValidateResponse} />
              </div>
            </div>
          </div>
        </div>

        {/* Footer */}
        <MobileFooter backButton={asnValidateResponse?.attributes.back_button} completeButton={asnValidateResponse?.attributes.complete_button} handleAction={handleAction} />
      </div>
    </div>
  ) : (
    <Loader />
  );
};

export default ReceiveCreate;
